module.exports = "<div>\n  <img src=\"https://www.gravatar.com/avatar/{{email_hash}}\"> <span class=\"email\">{{email}}</span>\n</div>\n"